module.exports = __webpack_public_path__ + "img/pocket-16_en.5b5a5b8.jpg";